import { TIER } from '../price';
import FEATURES from './features';

const PAID_TIERS = [TIER.PRO, TIER.PREMIUM];
const ALL_TIERS = [TIER.FREE, TIER.PRO, TIER.PREMIUM];

// TODO: add other features
// TODO: replace with a function to get tiers
const FEATURE_TO_TIERS = {
  [FEATURES.INDIVIDUAL_LINK_ANALYTICS]: PAID_TIERS,
  [FEATURES.REVENUE_ANALYTICS]: ALL_TIERS,
  [FEATURES.OVERALL_PAGE_PERFORMANCE_ANALYTICS]: PAID_TIERS,
  [FEATURES.SUBSCRIBER_AND_SUPPORTER_ANALYTICS]: PAID_TIERS,
  [FEATURES.LOCATION_BASED_ANALYTICS]: PAID_TIERS,
  [FEATURES.REFERRER_BASED_ANALYTICS]: PAID_TIERS,
  [FEATURES.DEVICE_BASED_ANALYTICS]: PAID_TIERS,
  [FEATURES.DIGITAL_ITEM_TEMPLATE]: ALL_TIERS,
  [FEATURES.ARTICLE_TEMPLATE]: ALL_TIERS,
  [FEATURES.LIST_TEMPLATES]: ALL_TIERS,
  [FEATURES.FILE_UPLOAD]: ALL_TIERS,
  [FEATURES.LIST_TEMPLATES]: ALL_TIERS,
  [FEATURES.PODCAST_AND_AUDIO_TEMPLATES]: PAID_TIERS,
  [FEATURES.VIDEO_TEMPLATE]: PAID_TIERS,
  [FEATURES.COURSE_BUILDER]: PAID_TIERS,
  [FEATURES.DIGITAL_EVENT_TEMPLATE]: ALL_TIERS,
  [FEATURES.HEADERS]: ALL_TIERS,
  [FEATURES.EMBED_YOUTUBE]: ALL_TIERS,
  [FEATURES.EMBED_CALENDLY]: ALL_TIERS,
  [FEATURES.EMBED_VIMEO]: ALL_TIERS,
  [FEATURES.EMBED_TYPE_FORM]: ALL_TIERS,
  [FEATURES.EMBED_ACAST]: ALL_TIERS,
  [FEATURES.EMBED_AMAZON_BOOKS]: ALL_TIERS,
  [FEATURES.EMBED_GOOGLE_MAPS]: ALL_TIERS,
  [FEATURES.UNLIMITED_LINKS]: ALL_TIERS,
  [FEATURES.SPOTIFY]: ALL_TIERS,
  [FEATURES.COLLECT_TIPS]: ALL_TIERS,
  [FEATURES.EMBED_SOUNDCLOUD]: ALL_TIERS,
  [FEATURES.EMBED_TWITTER]: ALL_TIERS,
  [FEATURES.CREATE_AND_SELL_MEMBERSHIP_AND_SUBSCRIPTIONS]: ALL_TIERS,
  [FEATURES.CAPTURE_EMAILS]: PAID_TIERS,
};

export default FEATURE_TO_TIERS;
